import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';

export const Adviser = styled.div`
  flex: 1;
  margin-left: 15px;
  text-align: left;

  > strong {
    display: block;
  }

  div {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const AdviserCompany = styled.span`
  display: block;
  ${getFont(-1, 'compact')};
  font-weight: 500;
  color: ${({ theme }) => theme.linkColor};
`;
